export default [
{
	path: 'orders',
	name: 'Order',
	component: resolve => require(['@/views/Order/index.vue'], resolve),
	meta: {
		title: '订单列表',
		name: 'Order'
	}
},
{
	path: 'orderinfo',
	name: 'OrderInfo',
	component: resolve => require(['@/views/OrderInfo/index.vue'], resolve),
	meta: {
		title: '订单详情',
		name: 'OrderInfo',
		isShow:true
	}
}];


// WEBPACK FOOTER //
// ./src/router/modules/order.route.js